var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackRightArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_52616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0904 20.2157C14.9221 20.0386 14.8305 19.8021 14.8357 19.5577C14.8409 19.3134 14.9424 19.081 15.1181 18.9111L20.7993 13.4231H0.916241C0.671426 13.4231 0.436637 13.3259 0.263527 13.1528C0.0904165 12.9796 -0.00683594 12.7449 -0.00683594 12.5C-0.00683594 12.2552 0.0904165 12.0204 0.263527 11.8473C0.436637 11.6742 0.671426 11.577 0.916241 11.577H20.8024L15.1181 6.08957C14.9424 5.91959 14.8408 5.68709 14.8357 5.44266C14.8305 5.19822 14.922 4.96162 15.0904 4.78434C15.1733 4.6969 15.2727 4.62676 15.3829 4.57799C15.4931 4.52922 15.6118 4.50278 15.7323 4.50021C15.8528 4.49763 15.9726 4.51897 16.0847 4.56299C16.1969 4.60701 16.2992 4.67283 16.3858 4.75665L23.7169 11.8336C23.8061 11.9201 23.877 12.0237 23.9254 12.1382C23.9739 12.2527 23.9988 12.3757 23.9988 12.5C23.9988 12.6243 23.9739 12.7474 23.9254 12.8619C23.877 12.9763 23.8061 13.0799 23.7169 13.1665L16.3858 20.2434C16.2992 20.3272 16.1968 20.393 16.0846 20.4369C15.9724 20.4809 15.8526 20.5022 15.7322 20.4996C15.6117 20.4969 15.493 20.4704 15.3828 20.4216C15.2726 20.3728 15.1733 20.3026 15.0904 20.2151V20.2157Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_52616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRightArrowIcon);
export default __webpack_public_path__ + "static/media/black-right-arrow-icon.0e32aad19f82770b03d46abcc20ce269.svg";
export { ForwardRef as ReactComponent };